export interface BalanceCostModel {
  searchStr: string;
  structuredData: {
    data: {
      info: {
        chef: string;
        city: string;
        customerManagementOfficer: string;
        mealPriceTitle: string;
        menuAccountingOfficer: string;
        nutritionSpecialist: string;
        title: string;
        weekTitle: string;
        year: number;
      };
      items: Day[];
    };
    metadata: {
      isUsed: boolean;
      toDate: string;
      fromDate: string;
      hasAfternoon: boolean;
    };
  };
  metadata: Metadata;
  parentId: string;
  type: string;
  deletedAt: string | null;
  updatedAt: string;
}

export interface Day {
  note: string | null;
  dishes: string[];
  items: Item[];
  price: Price;
  weekDay: string;
  datetime: string;
  afternoons: string[][];
  additionCharges: AdditionCharge[];
}

export interface Item {
  raw: string;
  name: string;
  unit: number | null;
  price: number;
  /**
   * Đơn vị tính có thể là số hoặc chuỗi tùy theo dữ liệu thực tế như quả, cái, hộp...
   */
  quantity: number | string | null;
}

export interface Price {
  tax: number;
  total: number;
  afternoon: number;
  itemPrice: number;
  additionPrice: number;
}

export interface AdditionCharge {
  name: string;
  price: number;
}

export interface Metadata {
  v20241121: V20241121;
}

export interface V20241121 {
  day: number;
  week: number;
  year: number;
  month: number;
  state: string;
}

export interface BalanceCostFilterModel {
  week?: number;
  /** `YYYY-MM` — khung thực đơn của năm học, KHÔNG phải số tháng của năm dương lịch. */
  month?: string;
  state?: DetailMenuBalanceOperationEnum;
  template?: string;
}

export enum DetailMenuBalanceOperationEnum {
  confirm = 'confirm',
  complete = 'complete',
}
